<simple-header title="Búsqueda avanzada" (action)="close()" icon="close"></simple-header>
<div class="content-scroll">

  <form [formGroup]="searchFormGroup">
    <predictive-searcher
      formControlName="selectedProjectForm"
      label="Proyecto"
      [service]="searchProjectAdapter"
      class=""></predictive-searcher>
    <div class="inline-flex">
        <div class="inline-flex column">
            <dropdown-selector
                class="column margin-right-8"
                [(selected)]="technology"
                label="Tecnología"
                [types]="technologies"
                (selectedChange)="onChangeTechnology($event)"></dropdown-selector>
            <mat-form-field appearance="outline" class="column margin-right-column-8">
                <mat-label>Potencia</mat-label>
                <input formControlName="power" matInput maxlength="20">
                <mat-error>
                    La potencia es obligatoria
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="margin-bottom-16">
      <mat-checkbox [(ngModel)]="withoutNumber" [ngModelOptions]="{standalone: true}">Sin enumerar</mat-checkbox>
    </div>
    <mat-form-field *ngIf="!withoutNumber" appearance="outline" class="full-width">
      <mat-label>Número</mat-label>
      <input [readonly]="withoutNumber" matInput maxlength="20" formControlName="number">
    </mat-form-field>
    <predictive-searcher
      formControlName="neighborhoodForm"
      label="Barrio"
      [service]="searchNeighborhoodAdapter"
      class=""></predictive-searcher>
    <input-place
      *ngIf="config.showLocationFilter"
      label="Ubicación"
      placeholder="CLL 33 45"
      dark
      formControlName="location"
      appearance="fill"></input-place>
    <mat-checkbox [(ngModel)]="temporalUse" [ngModelOptions]="{standalone: true}">Uso temporal</mat-checkbox>
  </form>

  <div class="padding-bottom-8 button">
    <button (click)="filter()" mat-raised-button color="primary" class="button-size-200">Buscar</button>
  </div>

</div>
